import { Directive, inject, Input, OnInit, TemplateRef, ViewContainerRef } from '@angular/core';

import { Store } from '@ngrx/store';

import { selectLoggedInUser } from '../../@store/user/user.selectors';
import { UserDetails } from '../../@store/user/user.state.interface';

@Directive({
  selector: '[ciwcRoleAccess]',
  standalone: true,
})
export class RoleAccessDirective implements OnInit {
  @Input('ciwcRoleAccess') allowedRoles: string[] = [];

  private readonly store = inject(Store);
  private readonly templateRef = inject(TemplateRef<unknown>);
  private readonly viewContainer = inject(ViewContainerRef);

  ngOnInit() {
    this.store.select(selectLoggedInUser)?.subscribe((user) => {
      this.updateView(user);
    });
  }

  private updateView(user: UserDetails | null) {
    this.viewContainer.clear();

    if (user && this.hasAccess(user.roles)) {
      this.viewContainer.createEmbeddedView(this.templateRef);
    }
  }

  private hasAccess(userRoles: string[]): boolean {
    if (!userRoles || !this.allowedRoles) {
      return false;
    }

    return this.allowedRoles.some((role) => userRoles.includes(role));
  }
}
